import React, { useEffect, useState } from 'react';
import { Box, Grid, GridItem, Text, Flex, Icon, Avatar, Button } from '@chakra-ui/react';
import { FaClock, FaBook, FaSync, FaPrint } from 'react-icons/fa';
import { BASE_URL } from '../../../../../Globalapi/Globalapi';

const StudentTimetable = () => {
  const [timetableData, setTimetableData] = useState([]);
  const [days, setDays] = useState([]);
  const [studentId, setStudentId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Array of random background colors
  const colors = ["red.100", "green.100", "blue.100", "yellow.100", "orange.100", "purple.100"];

  useEffect(() => {
    const token = sessionStorage.getItem('jwt');
    const storedStudentId = sessionStorage.getItem('user_id');
    if (storedStudentId) {
      setStudentId(storedStudentId);
    }

    const fetchTimetable = async () => {
      if (!studentId) return;

      try {
        const response = await fetch(`${BASE_URL}/admin/timetable/list_timetable_to_student.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ pass: studentId }), // Corrected payload key
        });

        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }

        const data = await response.json();
        if (data.success) {
          setTimetableData(data.timeTable || []); // Adjusted to match PHP response
        } else {
          throw new Error(data.message || 'Error fetching timetable data.');
        }
      } catch (error) {
        console.error('Error fetching timetable:', error);
        setError('An error occurred while fetching timetable data.');
      } finally {
        setLoading(false);
      }
    };

    const fetchDays = async () => {
      try {
        const response = await fetch(`${BASE_URL}/admin/timetable/day_master.php`);
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }

        const data = await response.json();
        if (Array.isArray(data.data)) {
          setDays(data.data.map(day => day.day));
        } else {
          throw new Error('Unexpected response format for days.');
        }
      } catch (error) {
        console.error('Error fetching days:', error);
        setError('An error occurred while fetching days data.');
      }
    };

    fetchTimetable();
    fetchDays();
  }, [studentId]);

  if (loading) {
    return <Text>Loading...</Text>;
  }

  if (error) {
    return <Text color="red.500">{error}</Text>;
  }

  return (
    <Box >
        <Box>

          <Grid
            templateColumns={{
              base: "1fr",        // 1 column on mobile
              sm: "repeat(2, 1fr)", // 2 columns on small screens (e.g., small tablets)
              md: "repeat(3, 1fr)", // 3 columns on medium screens (e.g., tablets)
              lg: "repeat(5, 1fr)", // 5 columns on large screens (e.g., laptops/desktops)
            }}
            gap={6}
            mt={1}
            // p={4}
          >
            {days.length > 0 ? (
              days.map((day, i) => (
                <GridItem key={i}>
                  <Text fontWeight="bold" mb={3}>
                    {day}
                  </Text>
                  {timetableData.length > 0 ? (
                    timetableData
                      .filter(slot => slot.day === day)
                      .map((slot, j) => (
                        <Box
                          key={j}
                          bg={colors[Math.floor(Math.random() * colors.length)]} // Random color
                          p={{ base: 2, md: 4 }} // Smaller padding for mobile
                          borderRadius="md"
                          mb={4}
                        >
                          <Flex alignItems="center" mb={2}>
                            <Icon as={FaClock} color="gray.500" mr={2} />
                            <Text>
                              {slot.start_time} - {slot.end_time}
                            </Text>
                          </Flex>
                          <Flex alignItems="center" mb={2}>
                            <Icon as={FaBook} color="gray.500" mr={2} />
                            <Text>Subject: {slot.subject}</Text>
                          </Flex>
                          <Flex alignItems="center">
                            <Avatar src={slot.image_url || ""} size="sm" mr={2} />
                            <Text>{slot.staff_name}</Text>
                          </Flex>
                        </Box>
                      ))
                  ) : (
                    <Text>No timetable data available.</Text>
                  )}
                </GridItem>
              ))
            ) : (
              <Text>Loading days...</Text>
            )}
          </Grid>

        </Box>
    </Box>
  );
};

export default StudentTimetable;
